import { SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { IGeoAreaGeom } from "../models";

interface IGetGeoAreasGeomParams {
  geoAreasIds: number[];
}

export class GeoAreaApi {
  static async getGeoAreasGeom({
    geoAreasIds,
  }: IGetGeoAreasGeomParams): Promise<
    SimpleResult<IGeoAreaGeom[]> | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/geoAreas/get-geo-areas-geom`;
    const response = await Api.post<SimpleResult<IGeoAreaGeom[]> | undefined>(
      requestUrl,
      { geoAreasIds },
    );

    return response?.data;
  }
}
